import {MenuItem} from "@mui/material";
import * as Units from "./Units";
import * as React from "react";
import {FormTextField} from "./FormTextField";
const defaultSx = {marginTop: 1}
function UnitSelector(props) {
  const {id, disabled, unitValue, onValueChange, excludeValues, sx, overrideUnits} = props

  const excludeValuesSafe = excludeValues === undefined ? [] : excludeValues
  const units = overrideUnits !== undefined ? overrideUnits.filter(um => ! excludeValuesSafe.includes(um.unitType))
          : Units.unitMap.filter(um => ! excludeValuesSafe.includes(um.unitType))

  function onChangeLocal(evt) {
    onValueChange(id, evt.target.value)
  }

  return (
      <FormTextField select size={'small'} sx={sx ? sx : defaultSx}
              id={`unit-select-${id}`}
              disabled={disabled}
              label={'Unit'}
              value={unitValue}
              onChange={onChangeLocal}>
        {
          units.map((um) => {
            return <MenuItem key={um.unitType} value={um.unitType}>{um.unitLabel}</MenuItem>
          })
        }
      </FormTextField>
  )
}

export {UnitSelector}